import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { CtvetstudentService } from './ctvetstudent.service';




@Component({
  selector: 'app-registerctvetstudent',
  templateUrl: './registerctvetstudent.component.html',
  styleUrls: ['./registerctvetstudent.component.css']
})
export class RegisterctvetstudentComponent {

  courses = [
    { name: 'Garment Making' },
    { name: 'English Language' },
    { name: 'Information Communication Technology' }
    // Add other courses as needed
  ];

  fullname: string = '';
  vmsId: string = '';
  selectedCourse: any = null;
  date: string = '';
  group: string = '';


  public loading = false;


  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

    constructor(private breakpointObserver: BreakpointObserver, private ctvetstudentservice: CtvetstudentService){
    }


    onSubmit(form: any) {
      // Check for empty fields and display alerts
      if (!this.fullname || !this.vmsId || !this.date || !this.selectedCourse || !this.group) {
        alert('Please fill in all required fields.');
        return;
      }
  
      // Prepare the student information object
      const studentInfo = {
        fullname: this.fullname,
        vmsId: this.vmsId,
        course: this.selectedCourse?.name,
        groupName: this.group,
        date: this.date
      };
  
      // Call the service to save the student info
      this.ctvetstudentservice.saveStudentInfo(studentInfo).subscribe(
        response => {
          alert('Student information saved successfully!');
          // Optionally reset the form or navigate to another page
          form.reset();
        },
        error => {
          alert('Error saving student information. Please try again.');
          console.error('Error:', error);
        }
      );
    }
}
